// indexedDB.js
import { openDB } from 'idb';

const DB_NAME = 'AppStorageDB';
const STORE_NAME = 'module_states';

export const initDB = async () => {
  return openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'id' });
      }
    },
  });
};

export const saveModuleState = async (moduleKey, state) => {
  const db = await initDB();
  await db.put(STORE_NAME, { id: moduleKey, ...state });
};

export const getModuleState = async (moduleKey) => {
  const db = await initDB();
  return db.get(STORE_NAME, moduleKey);
};

export const clearModuleState = async (moduleKey) => {
  const db = await initDB();
  await db.delete(STORE_NAME, moduleKey);
};
